<template>
    <a-spin :tip="$t('Loading...')" :spinning="getting_data">
        <div class="min-h-100vh">
            <div class="p-16">
                <div class="row">
                    <div class="col-6 text-left black" @click="$router.replace({ path: '/profile' })">
                        <div class="row">
                            <span class="fs-18 fw-600">{{ userFirstName }}</span>
                        </div>
                        <div class="row">
                            <span class="fs-13 fw-600">{{ userLastName }}</span>
                        </div>
                    </div>
                    <div class="col-6 text-right" style="margin: auto 0">
                        <img src="/resources/images/button-search.png" class="br-100 icon-home-right-top mr-16 clickable" @click="$router.replace({ path: '/search' })" />
                        <img src="/resources/images/button-favorite.png" class="br-100 icon-home-right-top clickable" @click="$router.replace({ path: '/favorite' })" />
                    </div>
                </div>
            </div>
            <div v-for="(home, homeKey) in configHome" :key="`configHome${homeKey}`">
                <template v-if="home.children.length">
                    <div v-if="home.layout == 'TopMenu'" class="p-16">
                        <div class="bg-white br-12 p-16">
                            <div v-for="(childrenRow, childrenRowKey) in home.children" :key="`TopMenuRow${childrenRowKey}`" class="row" :class="[childrenRowKey > 0 ? 'mt-16' : '']">
                                <div v-for="(childrenCol, childrenColKey) in childrenRow" :key="`TopMenuCol${childrenColKey}`" class="col-4 homeTopMenu clickable text-center" @click="onClick(childrenCol.link)">
                                    <img :src="childrenCol.image_url" class="br-100" />
                                    <br />
                                    <span class="fs-16 fw-600">{{ childrenCol.link.title }}</span>
                                </div>
                                <div v-for="index in 3 - childrenRow.length" :key="`${home.layout}EmptyDiv${index}`" class="col-4"></div>
                            </div>
                        </div>
                    </div>
                    <div v-if="home.layout == 'TopMenu2'" class="p-16">
                        <!-- <div class="bg-white br-12 p-16 TopMenu">
                            <swiper class="swiper" :options="swiperOptionTopMenu2">
                                <swiper-slide v-for="(slide, slideIndex) in home.children" :key="`${home.layout}${slideIndex}`">
                                    <div v-for="(childrenRow, childrenRowKey) in slide" :key="`TopMenu2Row${childrenRowKey}`" class="row" :class="[childrenRowKey > 0 ? 'mt-16' : '']">
                                        <div v-for="(childrenCol, childrenColKey) in childrenRow" :key="`TopMenu2Col${childrenColKey}`" class="col-4 homeTopMenu clickable text-center" @click="onClick(childrenCol.link)">
                                            <img :src="childrenCol.image_url" class="br-100" />
                                            <br />
                                            <span class="fs-13 fw-600">{{ childrenCol.link.title }}</span>
                                        </div>
                                        <div v-for="index in 3 - childrenRow.length" :key="`${home.layout}EmptyDiv${index}`" class="col-4"></div>
                                    </div>
                                </swiper-slide>
                            </swiper>
                        </div>
                        <div class="swiper-pagination-TopMenu2 mt-16 text-center" slot="pagination"></div> -->
                        <div class="bg-white br-12 p-16">
                            <carousel ref="carousel" :per-page="1" paginationPosition="bottom-overlay" paginationActiveColor="#cc0000" paginationColor="#999999" :paginationSize="8" :paginationPadding="4" loop>
                                <slide v-for="(slide, slideIndex) in home.children" :key="`${home.layout}${slideIndex}`" class="slide" :data-index="slideIndex + 1" :data-name="`slide-${slideIndex + 1}`">
                                    <div v-for="(childrenRow, childrenRowKey) in slide" :key="`TopMenu2Row${childrenRowKey}`" class="row" :class="[childrenRowKey > 0 ? 'mt-16' : '']">
                                        <div v-for="(childrenCol, childrenColKey) in childrenRow" :key="`TopMenu2Col${childrenColKey}`" class="col-4 homeTopMenu clickable text-center" @click="onClick(childrenCol.link)">
                                            <img :src="childrenCol.image_url" class="br-100" />
                                            <br />
                                            <span class="fs-16 fw-600">{{ childrenCol.link.title }}</span>
                                        </div>
                                        <div v-for="index in 3 - childrenRow.length" :key="`${home.layout}EmptyDiv${index}`" class="col-4"></div>
                                    </div>
                                </slide>
                            </carousel>
                        </div>
                        <div style="height: 24px"></div>
                    </div>
                    <div v-if="home.layout == 'TopBanner'" class="p-16">
                        <carousel class="carouselTopBanner" ref="carousel" :per-page="1" paginationPosition="bottom-overlay" paginationActiveColor="#cc0000" paginationColor="#999999" :paginationSize="8" :paginationPadding="4" loop>
                            <slide v-for="(slide, slideIndex) in home.children" :key="`${home.layout}${slideIndex}`" class="slide" :data-index="slideIndex + 1" :data-name="`slide-${slideIndex + 1}`">
                                <div class="row clickable" @click="onClick(slide.link)">
                                    <img :src="slide.image_url" class="w-100 br-20" />
                                </div>
                            </slide>
                        </carousel>
                        <div style="height: 32px"></div>
                    </div>
                    <div v-if="home.layout == 'TopBanner2'" class="p-16">
                        <!-- <swiper class="swiper" :options="swiperOptionTopBanner2">
                            <swiper-slide v-for="(slide, slideIndex) in home.children" :key="`${home.layout}${slideIndex}`">
                                <div class="row clickable" @click="onClick(slide.link)">
                                    <img :src="slide.image_url" class="w-100 br-20" />
                                </div>
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-pagination-TopBanner2 mt-16 text-center" slot="pagination"></div> -->
                        <carousel class="carouselTopBanner2" ref="carousel" :per-page="1" paginationPosition="bottom-overlay" paginationActiveColor="#cc0000" paginationColor="#999999" :paginationSize="8" :paginationPadding="4" loop autoplay>
                            <slide v-for="(slide, slideIndex) in home.children" :key="`${home.layout}${slideIndex}`" class="slide" :data-index="slideIndex + 1" :data-name="`slide-${slideIndex + 1}`">
                                <div class="row clickable" @click="onClick(slide.link)">
                                    <img :src="slide.image_url" class="w-100 br-20" />
                                </div>
                            </slide>
                        </carousel>
                        <!-- <div style="height: 48px"></div> -->
                    </div>
                    <div v-if="home.layout == 'TopBanner3'" class="p-16">
                        <carousel ref="carousel" :per-page="1" paginationPosition="bottom-overlay" paginationActiveColor="#cc0000" paginationColor="#999999" :paginationSize="8" :paginationPadding="4" loop>
                            <slide v-for="(slide, slideIndex) in home.children" :key="`${home.layout}${slideIndex}`" class="slide" :data-index="slideIndex + 1" :data-name="`slide-${slideIndex + 1}`">
                                <div class="row">
                                    <div v-for="(childrenCol, childrenColKey) in slide" :key="`TopBanner3Col${childrenColKey}`" class="col-3 homeTopBanner3 clickable text-center" @click="onClick(childrenCol.link)">
                                        <img :src="childrenCol.image_url" class="br-100" />
                                    </div>
                                    <div v-for="index in 4 - slide.length" :key="`${home.layout}EmptyDiv${index}`" class="col-3"></div>
                                </div>
                            </slide>
                        </carousel>
                        <div style="height: 48px"></div>
                    </div>
                    <div v-if="home.layout == 'MiddleBanner1'">
                        <carousel ref="carousel" :per-page="1" paginationPosition="bottom-overlay" paginationActiveColor="#cc0000" paginationColor="#999999" :paginationSize="8" :paginationPadding="4" loop>
                            <slide v-for="(slide, slideIndex) in home.children" :key="`${home.layout}${slideIndex}`" class="slide" :data-index="slideIndex + 1" :data-name="`slide-${slideIndex + 1}`">
                                <div class="row">
                                    <div v-for="(childrenCol, childrenColKey) in slide" :key="`MiddleBanner1Col${childrenColKey}`" class="col-6 clickable text-left" @click="onClick(childrenCol.link)">
                                        <div class="bg-white br-12" :class="[childrenColKey % 2 != 0 ? 'float-right mr-16 ml-8' : 'ml-16 mr-8']">
                                            <img :src="childrenCol.image_url" class="btlr-btrr-12 w-100" />
                                            <div class="p-10-10-0-10">
                                                <span class="fs-18 fw-600 red">{{ childrenCol.link.title }}</span>
                                            </div>
                                            <div class="p-10 pb-16">
                                                <span class="fs-13 fw-600 two-lines">{{ childrenCol.link.sub_title }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-for="index in 2 - slide.length" :key="`${home.layout}EmptyDiv${index}`" class="col-6"></div>
                                </div>
                            </slide>
                        </carousel>
                        <div style="height: 48px"></div>
                    </div>
                    <div v-if="home.layout == 'MiddleBanner2'">
                        <!-- <carousel ref="carousel" :per-page="1" paginationPosition="bottom-overlay" paginationActiveColor="#cc0000" paginationColor="#999999" :paginationSize="0" :paginationPadding="4" loop>
                            <slide v-for="(slide, slideIndex) in home.children" :key="`${home.layout}${slideIndex}`" class="slide" :data-index="slideIndex + 1" :data-name="`slide-${slideIndex + 1}`">
                                <div class="row">
                                    <div v-for="(childrenCol, childrenColKey) in slide" :key="`MiddleBanner2Col${childrenColKey}`" class="col-6 clickable" @click="onClick(childrenCol.link)">
                                        <div class="bg-white homeMiddleBanner1 br-12 text-left" :class="[childrenColKey % 2 != 0 ? 'float-right' : '']">
                                            <img :src="childrenCol.image_url" class="btlr-btrr-12" />
                                            <div class="p-10-10-0-10">
                                                <span class="fs-18 fw-600 red">{{ childrenCol.link.title }}</span>
                                            </div>
                                            <div class="p-10 pb-16">
                                                <span class="fs-13 fw-600 two-lines">{{ childrenCol.link.sub_title }}</span>
                                            </div>
                                        </div>
                                        <div v-for="index in 2 - slide.length" :key="`${home.layout}EmptyDiv${index}`" class="col-6"></div>
                                    </div>
                                </div>
                            </slide>
                        </carousel>
                        <div style="height: 48px"></div> -->
                        <!-- <div class="bg-white br-12 p-16 TopMenu"> -->
                        <!-- <swiper class="swiper" :options="swiperOptionMiddleBanner2">
                            <swiper-slide v-for="(slide, slideIndex) in home.children" :key="`${home.layout}${slideIndex}`">
                                <div class="row">
                                    <div v-for="(childrenCol, childrenColKey) in slide" :key="`MiddleBanner2Col${childrenColKey}`" class="col-6 clickable" @click="onClick(childrenCol.link)">
                                        <div class="bg-white homeMiddleBanner1 br-12 text-left" :class="[childrenColKey % 2 != 0 ? 'float-right' : '']">
                                            <img :src="childrenCol.image_url" class="btlr-btrr-12" />
                                            <div class="p-10-10-0-10">
                                                <span class="fs-18 fw-600 red">{{ childrenCol.link.title }}</span>
                                            </div>
                                            <div class="p-10 pb-16">
                                                <span class="fs-13 fw-600 two-lines">{{ childrenCol.link.sub_title }}</span>
                                            </div>
                                        </div>
                                        <div v-for="index in 2 - slide.length" :key="`${home.layout}EmptyDiv${index}`" class="col-6"></div>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper> -->
                        <!-- </div> -->
                        <!-- <div class="swiper-pagination-MiddleBanner2 mt-16 text-center" slot="pagination"></div> -->
                        <!-- MiddleBanner2 -->
                        <div class="p-16 MiddleBanner2Scroll">
                            <div v-for="(childrenCol, childrenColKey) in home.children" :key="`MiddleBanner2Col${childrenColKey}`" class="mr-16px bg-white text-left br-12">
                                <img :src="childrenCol.image_url" class="btlr-btrr-12 MiddleBanner2Img" />
                                <div class="p-10-10-0-10">
                                    <span class="fs-18 fw-600 red">{{ childrenCol.link.title }}</span>
                                </div>
                                <div class="p-10 pb-16">
                                    <span class="fs-13 fw-600 two-lines">{{ childrenCol.link.sub_title }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="home.layout == 'MiddleBanner3'" class="p-16">
                        <!-- <div v-for="(childrenCol, childrenColKey) in home.children" :key="`MiddleBanner3Col${childrenColKey}`" class="clickable" @click="onClick(childrenCol.link)">
                            <div class="bg-white br-12">
                                <img :src="childrenCol.image_url" class="btlr-btrr-12" />
                                <div class="p-10-10-0-10">
                                    <span class="fs-18 fw-600 red">{{ childrenCol.link.title }}</span>
                                </div>
                                <div class="p-10 pb-16">
                                    <span class="fs-13 fw-600 two-lines">{{ childrenCol.link.sub_title }}</span>
                                </div>
                            </div>
                        </div> -->
                        <carousel class="carouselMiddleBanner3" ref="carousel" :per-page="1" paginationPosition="bottom-overlay" paginationActiveColor="#cc0000" paginationColor="#999999" :paginationSize="8" :paginationPadding="4" loop>
                            <slide v-for="(slide, slideIndex) in home.children" :key="`${home.layout}${slideIndex}`" class="slide" :data-index="slideIndex + 1" :data-name="`slide-${slideIndex + 1}`">
                                <div class="bg-white br-12">
                                    <img :src="slide.image_url" class="btlr-btrr-12" />
                                    <div class="p-10-10-0-10">
                                        <span class="fs-18 fw-600 red">{{ slide.link.title }}</span>
                                    </div>
                                    <div class="p-10 pb-16">
                                        <span class="fs-13 fw-600 two-lines">{{ slide.link.sub_title }}</span>
                                    </div>
                                </div>
                            </slide>
                        </carousel>
                        <!-- <div style="height: 48px"></div> -->
                        <!-- MiddleBanner3 -->
                    </div>
                    <div v-if="home.layout == 'MiddleBanner4'" class="p-16-0">
                        <!-- <carousel ref="carousel" :per-page="1" paginationPosition="bottom-overlay" paginationActiveColor="#cc0000" paginationColor="#999999" :paginationSize="8" :paginationPadding="4" loop>
                            <slide v-for="(childrenCol, slideIndex) in home.children" :key="`${home.layout}${slideIndex}`" class="slide" :data-index="slideIndex + 1" :data-name="`slide-${slideIndex + 1}`">
                                <div class="clickable" @click="onClick(childrenCol.link)">
                                    <div class="bg-white br-12">
                                        <img :src="childrenCol.image_url" class="btlr-btrr-12" />
                                        <div class="p-10-10-0-10">
                                            <span class="fs-18 fw-600 red">{{ childrenCol.link.title }}</span>
                                        </div>
                                        <div class="p-10 pb-16">
                                            <span class="fs-13 fw-600 two-lines">{{ childrenCol.link.sub_title }}</span>
                                        </div>
                                    </div>
                                </div>
                            </slide>
                        </carousel>
                        <div style="height: 48px"></div> -->
                        <!-- <swiper class="swiper" :options="swiperOptionMiddleBanner4">
                            <swiper-slide v-for="(slide, slideIndex) in home.children" :key="`${home.layout}${slideIndex}`">
                                <div class="clickable" @click="onClick(slide.link)">
                                    <div class="bg-white br-12">
                                        <img :src="slide.image_url" class="btlr-btrr-12" />
                                        <div class="p-10-10-0-10">
                                            <span class="fs-18 fw-600 red">{{ slide.link.title }}</span>
                                        </div>
                                        <div class="p-10 pb-16">
                                            <span class="fs-13 fw-600 two-lines">{{ slide.link.sub_title }}</span>
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>
                        <div style="height: 48px"></div> -->
                        <!-- <div class="swiper-pagination-MiddleBanner2 mt-16 text-center" slot="pagination"></div> -->
                        <!-- MiddleBanner4 -->
                        <div class="p-16 MiddleBanner4Scroll">
                            <div v-for="(childrenCol, childrenColKey) in home.children" :key="`MiddleBanner4Col${childrenColKey}`" class="mr-16px bg-white text-left br-12">
                                <img :src="childrenCol.image_url" class="btlr-btrr-12 MiddleBanner4Img" />
                                <div class="p-10-10-0-10">
                                    <span class="fs-18 fw-600 red">{{ childrenCol.link.title }}</span>
                                </div>
                                <div class="p-10 pb-16">
                                    <span class="fs-13 fw-600 two-lines">{{ childrenCol.link.sub_title }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="home.layout == 'MiddleBanner5'" class="p-16">
                        <!-- <div v-for="(childrenRow, childrenRowKey) in home.children" :key="`MiddleBanner5Row${childrenRowKey}`" class="row">
                            <div v-for="(childrenCol, childrenColKey) in childrenRow" :key="`MiddleBanner5Col${childrenColKey}`" class="col-6 clickable" @click="onClick(childrenCol.link)">
                                <div class="homeMiddleBanner5 br-12 text-center" :class="[childrenColKey % 2 != 0 ? 'float-right' : '']">
                                    <img :src="childrenCol.image_url" class="br-12" />
                                    <div class="p-10-10-0-10">
                                        <span class="fs-18 fw-600 red">{{ childrenCol.link.title }}</span>
                                    </div>
                                    <div class="p-10 pb-16">
                                        <span class="fs-13 fw-600 two-lines">{{ childrenCol.link.sub_title }}</span>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <carousel class="carouselMiddleBanner5" ref="carousel" :per-page="1" paginationPosition="bottom-overlay" paginationActiveColor="#cc0000" paginationColor="#999999" :paginationSize="8" :paginationPadding="4" loop>
                            <slide v-for="(slide, slideIndex) in home.children" :key="`${home.layout}${slideIndex}`" class="slide" :data-index="slideIndex + 1" :data-name="`slide-${slideIndex + 1}`">
                                <div class="row">
                                    <div v-for="(childrenCol, childrenColKey) in slide" :key="`MiddleBanner5Col${childrenColKey}`" class="col-6 clickable" @click="onClick(childrenCol.link)">
                                        <div class="homeMiddleBanner5 br-12 text-center" :class="[childrenColKey % 2 != 0 ? 'float-right' : '']">
                                            <img :src="childrenCol.image_url" class="br-12" />
                                            <div class="p-10-10-0-10">
                                                <span class="fs-18 fw-600 red">{{ childrenCol.link.title }}</span>
                                            </div>
                                            <div class="p-10 pb-16">
                                                <span class="fs-13 fw-600 two-lines">{{ childrenCol.link.sub_title }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-for="index in 2 - slide.length" :key="`${home.layout}EmptyDiv${index}`" class="col-6"></div>
                                </div>
                            </slide>
                        </carousel>
                        <!-- MiddleBanner5 -->
                    </div>
                    <div v-if="home.layout == 'MiddleBanner6'" class="p-16-0">
                        <!-- <carousel ref="carousel" :per-page="1" paginationPosition="bottom-overlay" paginationActiveColor="#cc0000" paginationColor="#999999" :paginationSize="0" :paginationPadding="4" loop>
                            <slide v-for="(slide, slideIndex) in home.children" :key="`${home.layout}${slideIndex}`" class="slide" :data-index="slideIndex + 1" :data-name="`slide-${slideIndex + 1}`">
                                <div class="row">
                                    <div v-for="(childrenCol, childrenColKey) in slide" :key="`MiddleBanner6Col${childrenColKey}`" class="col-6 clickable" @click="onClick(childrenCol.link)">
                                        <div class="homeMiddleBanner5 br-12" :class="[childrenColKey % 2 != 0 ? 'float-right' : '']">
                                            <img :src="childrenCol.image_url" class="br-12" />
                                            <div class="p-10-10-0-10">
                                                <span class="fs-18 fw-600 red">{{ childrenCol.link.title }}</span>
                                            </div>
                                            <div class="p-10 pb-16">
                                                <span class="fs-13 fw-600 two-lines">{{ childrenCol.link.sub_title }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </slide>
                        </carousel>
                        <div style="height: 48px"></div> -->
                        <!-- <swiper class="swiper" :options="swiperOptionMiddleBanner6">
                            <swiper-slide v-for="(slide, slideIndex) in home.children" :key="`${home.layout}${slideIndex}`">
                                <div class="row">
                                    <div v-for="(childrenCol, childrenColKey) in slide" :key="`MiddleBanner6Col${childrenColKey}`" class="col-6 clickable" @click="onClick(childrenCol.link)">
                                        <div class="MiddleBanner6 br-12" :class="[childrenColKey % 2 != 0 ? 'float-right mr-16 ml-8' : 'ml-16 mr-8']">
                                            <img :src="childrenCol.image_url" class="br-12" />
                                            <div class="p-10-10-0-10">
                                                <span class="fs-18 fw-600 red">{{ childrenCol.link.title }}</span>
                                            </div>
                                            <div class="p-10 pb-16">
                                                <span class="fs-13 fw-600 two-lines">{{ childrenCol.link.sub_title }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-for="index in 2 - slide.length" :key="`${home.layout}EmptyDiv${index}`" class="col-6"></div>
                                </div>
                            </swiper-slide>
                        </swiper>
                        <div style="height: 48px"></div> -->
                        <!-- MiddleBanner6 -->
                        <div class="p-16 MiddleBanner6Scroll">
                            <div v-for="(childrenCol, childrenColKey) in home.children" :key="`MiddleBanner6Col${childrenColKey}`" class="mr-16px text-center br-12">
                                <img :src="childrenCol.image_url" class="btlr-btrr-12 MiddleBanner6Img" />
                                <div class="p-10-10-0-10">
                                    <span class="fs-18 fw-600 red">{{ childrenCol.link.title }}</span>
                                </div>
                                <div class="p-10 pb-16">
                                    <span class="fs-13 fw-600 two-lines">{{ childrenCol.link.sub_title }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="home.layout == 'FooterBanner1'">
                        <!-- <img :src="home.children[0].image_url" class="clickable" @click="onClick(home.children[0].link)" />
                        <div style="height: 48px"></div> -->
                        <carousel class="carouselFooterBanner1" ref="carousel" :per-page="1" paginationPosition="bottom-overlay" paginationActiveColor="#cc0000" paginationColor="#999999" :paginationSize="8" :paginationPadding="4" loop>
                            <slide v-for="(slide, slideIndex) in home.children" :key="`${home.layout}${slideIndex}`" class="slide" :data-index="slideIndex + 1" :data-name="`slide-${slideIndex + 1}`">
                                <div class="clickable homeFooterBanner1 text-center" @click="onClick(slide.link)">
                                    <img :src="slide.image_url" class="clickable" />
                                </div>
                            </slide>
                        </carousel>
                        <div style="height: 48px"></div>
                    </div>
                    <div v-if="home.layout == 'FooterBanner2'">
                        <carousel class="carouselFooterBanner2" ref="carousel" :per-page="1" paginationPosition="bottom-overlay" paginationActiveColor="#cc0000" paginationColor="#999999" :paginationSize="8" :paginationPadding="4" loop autoplay>
                            <slide v-for="(childrenCol, slideIndex) in home.children" :key="`${home.layout}${slideIndex}`" class="slide" :data-index="slideIndex + 1" :data-name="`slide-${slideIndex + 1}`">
                                <div class="clickable homeFooterBanner1 text-center" @click="onClick(childrenCol.link)">
                                    <img :src="childrenCol.image_url" />
                                </div>
                            </slide>
                        </carousel>
                        <div style="height: 48px"></div>
                    </div>
                </template>
                <!-- <div style="height: 48px"></div> -->
            </div>
        </div>
        <modal-form ref="modalForm" :key="modal_visible" :visible="modal_visible" :step="modal_step" :data="modal_data" @on-cancel="onModalCancel" />
        <div v-if="$device != 'mobile'" class="copyright-section-space"></div>
        <div v-if="$device != 'mobile'" class="copyright-section">© Copyright SCG Debenture Club. All Rights Reserved.</div>
    </a-spin>
</template>
<script>
import store from 'store';
import modalForm from './modalForm';
// import { Carousel, Slide } from 'vue-carousel';
/* import noImg from '../../../public/resources/json/no-img.json'; */
import _ from 'lodash';
/* import { Swiper, SwiperSlide } from 'vue-awesome-swiper'; */
export default {
    components: {
        // Carousel,
        // Slide,
        modalForm,
        /* Swiper,
        SwiperSlide, */
    },
    data: function () {
        return {
            current_page: 0,
            getting_data: true,
            slides: [],
            banner: [],
            menu_num: {},
            modal_visible: this.$mode != 'production',
            modal_step: 0,
            modal_data: {
                popup: [{ display_button: true, image: 'https://apigwd.scg.com/DebentureClubDev/images/popup/AVmPX1620644000.png', image_full: 'https://apigwd.scg.com/DebentureClubDev/images/popup/AVmPX1620644000.png', msg: 'จัดที่ SCGggggggggggggggggggggggggggggggggggggggggggggggggg', title: 'เวิร์คช็อปแกะสลัก', type: 'activity', xid: 657 }],
            },
            not_show_again_ids: store.get('not_show_again_priv_ids_popup'),
            not_show_again: store.get('not_show_again_popup'),
            hideNavbar: false,
            lastScrollPosition: 0,
            configHome: [],
            slickOptions: {
                arrows: false,
                dots: false,
                slidesToShow: 1,
                centerMode: true,
            },
            swiperOptionTopMenu2: {
                slidesPerView: 'auto',
                // slidesPerView: 3,
                centeredSlides: true,
                // spaceBetween: 30,
                pagination: {
                    el: '.swiper-pagination-TopMenu2',
                    clickable: true,
                },
            },
            swiperOptionTopBanner2: {
                slidesPerView: 'auto',
                // slidesPerView: 3,
                centeredSlides: true,
                // spaceBetween: 30,
                pagination: {
                    el: '.swiper-pagination-TopBanner2',
                    clickable: true,
                },
            },
            swiperOptionMiddleBanner2: {
                slidesPerView: 'auto',
                // slidesPerView: 3,
                centeredSlides: true,
                // spaceBetween: 30,
                pagination: {
                    el: '.swiper-pagination-MiddleBanner2',
                    clickable: true,
                },
            },
            swiperOptionMiddleBanner4: {
                slidesPerView: 'auto',
                // slidesPerView: 3,
                centeredSlides: true,
                // spaceBetween: 30,
                pagination: {
                    el: '.swiper-pagination-MiddleBanner4',
                    clickable: true,
                },
            },
            swiperOptionMiddleBanner6: {
                slidesPerView: 'auto',
                // slidesPerView: 3,
                centeredSlides: true,
                // spaceBetween: 30,
                pagination: {
                    el: '.swiper-pagination-MiddleBanner6',
                    clickable: true,
                },
            },
        };
    },
    computed: {
        custodianNameArr() {
            return this.$store.state.user?.custodian_name?.split(' ') || [];
        },
        userFirstName() {
            return this.custodianNameArr[0] || '';
        },
        userLastName() {
            return this.custodianNameArr[1] || '';
        },
    },
    mounted() {
        this.getNumberNotRead(() => this.getConfigHome(() => (this.getting_data = false)));
    },
    methods: {
        onScroll() {
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            if (currentScrollPosition < 0) return;
            if (Math.abs(currentScrollPosition - this.lastScrollPosition) <= this.$refs.navbar.$el.clientHeight * 0.5) return;
            this.hideNavbar = currentScrollPosition >= this.lastScrollPosition;
            this.lastScrollPosition = currentScrollPosition;
        },
        getSlideBanner: function (callback = null) {
            this.$store.dispatch('user/GET', {
                payload: {
                    path: '/api/home/banner',
                    callback: (res) => {
                        if (res) {
                            res.slide.forEach((slide) => {
                                this.slides.push({
                                    image_url: slide.image,
                                });
                            });
                            this.banner = res.banner;
                            if (typeof callback == 'function') callback();
                        } else if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        getNumberNotRead: function (callback = null) {
            this.$store.dispatch('user/GET', {
                payload: {
                    path: '/api/home/menu',
                    callback: (res) => {
                        if (res) {
                            this.menu_num = res;
                            if (this.menu_num.popup.length) {
                                this.modal_data.popup = this.menu_num.popup;
                                if (this.not_show_again != true) {
                                    if (this.not_show_again_ids != undefined) {
                                        for (var i = 0; i < this.modal_data.popup.length; i++) {
                                            if (i >= this.modal_step && this.not_show_again_ids.indexOf(this.modal_data.popup[i].priv_id) == -1) {
                                                this.modal_step = i;
                                                this.modal_visible = true;
                                                break;
                                            }
                                        }
                                    } else {
                                        this.modal_visible = true;
                                    }
                                }
                                store.set('not_show_again_popup', true);
                            }
                            if (typeof callback == 'function') callback();
                        } else if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        logout() {
            this.$store.dispatch('user/LOGOUT');
        },
        handleClickImage(link) {
            window.open(link, '_blank');
        },
        handleSlideClick(dataset) {
            console.log(dataset.index, dataset.name);
        },
        handlePageChange(page) {
            this.current_page = page;
        },
        handleNext() {
            if (this.current_page < 2) {
                this.current_page = this.current_page + 1;
                this.$refs.carousel.goToPage(this.current_page);
            }
        },
        onModalCancel() {
            this.modal_visible = false;
            if (this.modal_data.popup.length > 1) {
                if (this.modal_data.popup.length - 1 > this.modal_step) {
                    this.modal_step = this.modal_step + 1;
                    if (this.not_show_again_ids != undefined) {
                        for (var i = 0; i < this.modal_data.popup.length; i++) {
                            if (i >= this.modal_step && this.not_show_again_ids.indexOf(this.modal_data.popup[i].priv_id) == -1) {
                                this.modal_step = i;
                                this.getting_data = true;
                                setTimeout(() => {
                                    this.modal_visible = true;
                                    this.getting_data = false;
                                }, 500);
                                break;
                            }
                        }
                    } else {
                        this.modal_visible = true;
                    }
                }
            }
        },
        getConfigHome: function (callback = null) {
            this.configHome = [];
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/home-api/api/configHome',
                    callback: (res) => {
                        if (res?.data?.length) {
                            this.configHome = _.map(res.data, (v, k) => {
                                if ((v.layout == 'TopMenu' || v.layout == 'TopMenu2') && !_.isEmpty(v.children)) {
                                    /* v.children = this.atg(v.children, 3); */
                                    const sorted1 = [];
                                    const sorted2 = [];
                                    _.each(v.children, (v1, k1) => {
                                        if (k1 % 2 == 0) sorted1.push(v1);
                                        else sorted2.push(v1);
                                    });
                                    v.children = this.atg([...sorted1, ...sorted2], 3);
                                }
                                if (v.layout == 'TopMenu2' && !_.isEmpty(v.children) && v.children.length > 2) v.children = this.atg(v.children, 2);
                                if (v.layout == 'TopBanner3' && !_.isEmpty(v.children)) v.children = this.atg(v.children, 4);
                                if ((v.layout == 'MiddleBanner1' /* || v.layout == 'MiddleBanner2' */ || v.layout == 'MiddleBanner5') /* || v.layout == 'MiddleBanner6' */ && !_.isEmpty(v.children)) v.children = this.atg(v.children, 2);
                                // if ((v.layout == 'MiddleBanner1' || v.layout == 'MiddleBanner3' || v.layout == 'MiddleBanner5' || v.layout == 'FooterBanner1') && !_.isEmpty(v.children)) v.children.length = 1;
                                if (_.isEmpty(v.children)) v.layout = null;
                                // if (v.layout == 'MiddleBanner2') console.log('v.children -->', v.children);
                                return v;
                            });
                            if (typeof callback == 'function') callback();
                        } else if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        onClick(link) {
            if (link?.type && link.type != '' && link?.xid)
                switch (link.type) {
                    case 'url':
                        window.open(link.xid, '_blank');
                        break;
                    case 'menu':
                        switch (link.xid) {
                            case 'news':
                                this.r('/inbox');
                                break;
                            case 'history':
                                this.r('/log');
                                break;
                            default:
                                this.r(`/${link.xid}`);
                                break;
                        }
                        break;
                    case 'news':
                        this.r('/inbox-detail', { inbox_id: link.xid });
                        break;
                    case 'privilege':
                        this.r('/privilege-detail', { priv_id: link.xid });
                        break;
                    case 'reward':
                        this.r('/reward-condition', { priv_id: link.xid });
                        break;
                    case 'activity':
                        this.r('/activity-detail', { act_id: link.xid });
                        break;
                    case 'delight':
                        this.r('/delight-detail', { delight_id: link.xid });
                        break;
                    default:
                        break;
                }
        },
        replaceErrorImg(e) {
            /* e.target.src = noImg.base64; */
        },
        next() {
            this.$refs.slick.next();
        },
        prev() {
            this.$refs.slick.prev();
        },
        reInit() {
            this.$nextTick(() => {
                this.$refs.slick.reSlick();
            });
        },
        handleAfterChange(event, slick, currentSlide) {
            console.log('handleAfterChange -->', event, slick, currentSlide);
        },
        handleBeforeChange(event, slick, currentSlide, nextSlide) {
            console.log('handleBeforeChange -->', event, slick, currentSlide, nextSlide);
        },
        handleBreakpoint(event, slick, breakpoint) {
            console.log('handleBreakpoint -->', event, slick, breakpoint);
        },
        handleDestroy(event, slick) {
            console.log('handleDestroy -->', event, slick);
        },
        handleEdge(event, slick, direction) {
            console.log('handleEdge -->', event, slick, direction);
        },
        handleInit(event, slick) {
            console.log('handleInit -->', event, slick);
        },
        handleReInit(event, slick) {
            console.log('handleReInit -->', event, slick);
        },
        handleSetPosition(event, slick) {
            console.log('handleSetPosition -->', event, slick);
        },
        handleSwipe(event, slick, direction) {
            console.log('handleSwipe -->', event, slick, direction);
        },
        handleLazyLoaded(event, slick, image, imageSource) {
            console.log('handleLazyLoaded -->', event, slick, image, imageSource);
        },
        handleLazeLoadError(event, slick, image, imageSource) {
            console.log('handleLazeLoadError -->', event, slick, image, imageSource);
        },
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll);
    },
};
</script>
<style lang="scss" module>
@import '@/components/cleanui/system/Auth/style.module.scss';
</style>
<style scoped>
.dot {
    border-radius: 50%;
    width: 8px;
    height: 8px;
    display: inline-block;
    margin-left: 8px;
}
.slide {
    background-color: transparent;
    width: 100%;
    text-align: center;
}
.image-slide {
    width: 100%;
}
.image-slide.is-desktop {
    max-width: 710px;
    /* max-height: 55vh; */
    width: auto;
}
.image-slide.is-tablet {
    max-width: 1024px;
    max-height: 55vh;
}
.bottom-images {
    width: 100%;
}
.bottom-images.is-desktop {
    max-width: 710px;
    margin: 0 auto;
    width: auto;
    display: grid;
    gap: 8px;
    grid-template-columns: repeat(2, 1fr);
    padding: 8px;
}
.bottom-images.is-tablet {
    /* max-width: 1024px; */
    margin: 0 auto;
}
.image {
    width: 100%;
}
.image.is-desktop {
    /* width: 49.5%; */
    padding: 0 !important;
}
.image.is-tablet {
    /* width: 33.3333%; */
    padding: 0 !important;
}
.section-icons {
    width: 100%;
    padding: 20px 0;
}
.main-icon {
    width: 114px;
}
.badge-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    background: url('../../../public/resources/images/notification-badge.png') no-repeat;
    background-size: 100%;
    width: 24px;
    height: 24px;
}
.badge-label {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    color: #fff !important;
    line-height: 24px;
    font-size: 14px;
}
.center-icons {
    justify-content: center;
    /* margin: -6% 0; */
    margin: -5vw 0;
}
.ml-1vw {
    margin-left: 1vw;
}
.TopMenu {
    /* width: calc(100vw - 32px); */
    width: calc(480px - 32px);
    margin: 0 auto;
}
.homeTopMenu img {
    /* width: calc(100% - 16px); */
    /* width: calc(19.63vw - 16px);
    height: calc(19.63vw - 16px); */
    /* width: 69px;
    height: 69px; */
    width: calc(19.63vw - 16px);
    height: calc(19.63vw - 16px);
    min-width: 46.8px;
    min-height: 46.8px;
    max-width: 68px;
    max-height: 68px;
}
.homeTopBanner3 {
    width: 14.953271vw;
    height: 14.953271vw;
    max-width: 64px;
    max-height: 64px;
    margin: 0 auto;
}
.homeTopBanner3 img {
    width: 14.953271vw;
    height: 14.953271vw;
    max-width: 64px;
    max-height: 64px;
}
.homeMiddleBanner1 {
    /* width: 41.12vw;
    max-width: 176px; */
    margin: 0 16px;
}
.homeMiddleBanner1 img {
    /* width: calc(100% - 8px); */
    width: 100%;
}
.homeMiddleBanner5 {
    width: 41.12vw;
    max-width: 176px;
}
.homeMiddleBanner5 img {
    /* width: calc(100% - 8px); */
    width: 100%;
    height: 26.7818575vh;
    max-height: 248px;
}
.MiddleBanner6 img {
    /* width: calc(100% - 8px); */
    width: 100%;
    height: 26.7818575vh;
    max-height: 248px;
    margin: 0 auto;
}
.homeFooterBanner1 img {
    width: 480px;
    height: 118px;
}
/* /deep/ .slick-slider {
    width: calc(236px * 2) !important;
} */
.custom-carousel {
    width: 170px; /* ❶ */
    overflow: hidden; /* ❷ */
}
.custom-carousel-inner {
    white-space: nowrap; /* ❸ */
}
.custom-carousel-card {
    width: 40px;
    margin-right: 10px;
    display: inline-flex;
    /* optional */
    height: 40px;
    background-color: #39b1bd;
    color: white;
    border-radius: 4px;
    align-items: center;
    justify-content: center;
}
@import '~swiper/css/swiper.css';
.swiper-slide {
    width: 80%;
    /* margin-right: 8px; */
    padding: 0 8px;
}
/* .swiper-slide:nth-child(2n) {
    margin-right: 16px;
}
.swiper-slide:nth-child(3n) {
    margin-right: 24px;
} */
/deep/ .swiper-pagination {
    position: relative;
}
/deep/ .swiper-pagination-bullet {
    margin: 0 4px;
    background-color: #999999 !important;
    opacity: 0.5;
}
/deep/ .swiper-pagination-bullet-active {
    background-color: #cc0000 !important;
    opacity: 1;
}
/deep/ .VueCarousel-dot {
    background-color: #999999 !important;
    opacity: 0.5;
}
/deep/ .VueCarousel-dot.VueCarousel-dot--active {
    background-color: #cc0000 !important;
    opacity: 1;
}
.icon-home-right-top {
    max-width: 32px;
    max-height: 32px;
}
/deep/ .carouselTopBanner > div:nth-child(2) {
    bottom: -32px !important;
}
/deep/ .carouselTopBanner2 > div:nth-child(2) {
    bottom: 4px !important;
}
/* Hide scrollbar for IE, Edge and Firefox */
.MiddleBanner2Scroll {
    overflow: scroll hidden;
    display: flex;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}
.MiddleBanner2Scroll::-webkit-scrollbar {
    display: none;
}
.MiddleBanner2Img {
    max-width: calc(222px - 16px);
}
/* Hide scrollbar for IE, Edge and Firefox */
.MiddleBanner4Scroll {
    overflow: scroll hidden;
    display: flex;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}
.MiddleBanner4Scroll::-webkit-scrollbar {
    display: none;
}
.MiddleBanner4Img {
    max-width: calc(446px - 16px);
}
/* Hide scrollbar for IE, Edge and Firefox */
.MiddleBanner6Scroll {
    overflow: scroll hidden;
    display: flex;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}
.MiddleBanner6Scroll::-webkit-scrollbar {
    display: none;
}
.MiddleBanner6Img {
    max-width: calc(222px - 16px);
}
/deep/ .carouselFooterBanner2 > div:nth-child(2) {
    bottom: 4px !important;
}
/deep/ .carouselMiddleBanner3 > div:nth-child(2) {
    bottom: -8px !important;
}
/deep/ .carouselMiddleBanner5 > div:nth-child(2) {
    bottom: -8px !important;
}
/deep/ .carouselFooterBanner1 > div:nth-child(2) {
    bottom: -24px !important;
}
@media (max-device-width: 480px) {
    .main-icon {
        width: 23vw;
    }
    .swiper-slide {
        padding: 0 1.87vw;
    }
    .TopMenu {
        width: calc(100vw - 32px);
    }
    .homeFooterBanner1 img {
        width: 100vw;
        height: 12.74vh;
    }
    .icon-home-right-top {
        max-width: 7.48vw;
        max-height: 7.48vw;
    }
    .MiddleBanner2Img {
        max-width: calc(45vw - 16px);
    }
    .MiddleBanner4Img {
        max-width: calc(90vw - 16px);
    }
    .MiddleBanner6Img {
        max-width: calc(45vw - 16px);
    }
}
</style>
